/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// pages
import SalesSummaries from "./SalesSummaries";
import Sales from "./Sales";
// apis
import { getCardSalesDetailExcel, getCardSalesSummaries, getCardSalesSummariesExcel } from "../../../../apis/finances/cards";
// components
import Filters from "../../../../components/Filters";
import { ControlTable } from "../../../../components/Table";
// utils
import { getDay } from "../../../../utils/date";
import { getParams } from "../../../../utils/params";
import useForm from "../../../../hooks/useForm";
import { cloneDeep, findIndex, isEmpty } from "lodash";
import { Link, useHistory } from "react-router-dom";
import Icon from "../../../../components/Icon";
import CommentIcon from "../../../../assets/images/icon/comment-icon.svg"
import PageHeader from "../../../../components/PageHeader";
import { downExcelFile } from "../../../../utils/download";

const SalesList = ({ permission, activeTab, tabList }) => {
  const history = useHistory()
  const [sortFields, setSortFields] = useState([
    { key: "payDate", order: 'desc' },
    { key: "trCount", order: '' },
    { key: "cardCompany", order: '' },
    { key: "buyAmt", order: '' },
    { key: "commAmt", order: '' },
    { key: "payAmt", order: '' },
    { key: "acctInAmt", order: '' }
  ])
  const [fields, setFields] = useState([]);
  const [resultRow, setResultRow] = useState({});
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFields([
      { title: "지급예정일", key: "payDate", type: "date", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "카드사", key: "cardCompany", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "거래건수", key: "trCount", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "결제금액", key: "buyAmt", type: "comma", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "지급예정액", key: "payAmt", type: "comma", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "입금액", key: "acctInAmt", type: "comma", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          )
        }
      }
    ])
  }, [sortFields])

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy
  } = useForm(
    {
      order: [
        {
          payDate: "desc",
        },
      ],
      range: {
        payDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date,
      },
      hasUnmatchAcctInAmt: false,
      page: 0,
      limit: 10,
      search: {
        cardCompany: "",
      }
    },
  )

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order))
    if (sortField)
    {
      setOrderBy(sortField)
    }
  }, [sortFields])

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    let _params = cloneDeep(params)
    if (!_params.hasUnmatchAcctInAmt) delete _params.hasUnmatchAcctInAmt
    setIsLoading(true);
    getCardSalesSummaries(getParams(_params))
      .then((res) => {
        const { totalCount, cardSalesSummaries, comment } = res.data
        const transList = cardSalesSummaries.map((invoice) => ({
          ...invoice,
          comments: comment.listByPost.find(c => c.postIdx === invoice.idx) || {}
        }))
        setResultRow({
          payDate: "",
          cardCompany: " ",
          trCount: res.data.trCountSum,
          buyAmt: res.data.buyAmtSum,
          commAmt: res.data.commAmtSum,
          payAmt: res.data.payAmtSum,
          acctInAmt: res.data.acctInAmtSum,
        });
        setList(transList);
        setTotal(totalCount);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filterConfig = [
    {
      title: "조회기간",
      type: "customdatepicker",
      key: "range.payDate",
    },
    {
      title: "입금 여부",
      type: "checkbox",
      key: "noClientMapped",
      label: "미입금 의심항목 보기",
      checked: form.hasUnmatchAcctInAmt,
      onChange: (check) => {
        setForm({
          ...form,
          hasUnmatchAcctInAmt: check
        })
      },
    },
    {
      title: "카드사 검색",
      key: "search.cardCompany",
      placeholder: '카드사 입력'
    },
  ]

  const handleRowClick = (data, e) => {
    const { tagName } = e.target;
    if (tagName === "SPAN") return;
    setOpen(true);
    setFormData(data);
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key)
    const idx = findIndex(sortFields, sortField)
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))]
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    }
    setSortFields(newArray)
  }

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key)
    return sortField.order
  }

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {

        const from = form.range.payDate[0]
        const to = form.range.payDate[1]

        getCardSalesSummariesExcel(getParams(form)).then((res) => {
          downExcelFile(res, `신용카드 매출 지급예정일별 내역 ${from}~${to}.xlsx`)
        })
        getCardSalesDetailExcel(getParams(form)).then((res) => {
          downExcelFile(res, `신용카드 매출 상세 내역 ${from}~${to}.xlsx`)
        })
      },
      disabled: isEmpty(list)
    },
  ];

  return (
    <>
      <PageHeader
        title={"신용카드 내역"}
        activeTab={activeTab}
        tabList={tabList}
        buttons={headerButtons}
      />
      <Filters
        isLoading={isLoading}
        filters={filterConfig}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        onSelect={handleRowClick}
        isLoading={isLoading}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        resultRow={resultRow}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        isExpand={true}
        expandCol={8}
        ExpandData={SalesSummaries}
        noDataText={
          <Link to="/manager/financial" className="text-align-center">
            <p className="color-gray-5 nowrap">
              {"조회된 내역이 없습니다. 필터 변경 또는"}
            </p>
            <p className="color-gray-5 nowrap">
              {"관리자 > 금융 정보 자동 수집 > 신용카드 매출 정보를 연동해주세요."}
            </p>
            <p className="color-main-80 font-size-15">
              {"클릭시 해당 메뉴로 이동합니다."}
            </p>
          </Link>
        }
      />
      <Sales
        permission={permission}
        open={open}
        setOpen={setOpen}
        data={formData}
        setData={setFormData}
        submit={filterSubmit}
      />
    </>
  );
};

export default SalesList;
